import { TradeOrder } from '../types';

export const orderCommodities = [
  { name: 'Copper Cathodes', unit: 't', min: 100, max: 1200, step: 25 },
  { name: 'Copper Concentrates', unit: 't', min: 500, max: 4200, step: 50 },
  { name: 'Gold Dore Bars', unit: 'kg', min: 10, max: 220, step: 5 },
  { name: 'Silver Bullion', unit: 'kg', min: 500, max: 9000, step: 250 },
  { name: 'Rough Diamonds', unit: 'ct', min: 120, max: 4800, step: 20 },
  { name: 'Coloured Gemstones', unit: 'kg', min: 2, max: 90, step: 2 },
];

export const destinations = [
  'Dubai, UAE',
  'Shanghai, China',
  'Antwerp, Belgium',
  'Mumbai, India',
  'Istanbul, Türkiye',
  'Zug, Switzerland',
  'Busan, South Korea',
  'Rotterdam, Netherlands',
  'Singapore',
  'Hamburg, Germany',
  'Ningbo, China',
  'Jaipur, India',
  'Johannesburg, South Africa',
  'Kuala Lumpur, Malaysia',
  'Milan, Italy',
  'Houston, USA',
  'Tokyo, Japan',
  'Bangkok, Thailand',
];

const buyerPrefixes = ['ORD', 'LMS', 'EXP'];
const incoterms = ['CIF', 'FOB', 'DDP', 'FCA'];
const statuses: TradeOrder['status'][] = [
  'Confirmed',
  'In transit',
  'Cleared customs',
  'Delivered',
  'Assay pending',
];

let counter = 4820;

const pick = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

const roundTo = (value: number, step: number) => Math.max(step, Math.round(value / step) * step);

const formatQty = (value: number, unit: string) =>
  `${value.toLocaleString('en-US')} ${unit}`;

export function createOrder(timestamp: Date, status?: TradeOrder['status']): TradeOrder {
  const commodity = pick(orderCommodities);
  const raw = commodity.min + Math.random() * (commodity.max - commodity.min);
  const qty = roundTo(raw, commodity.step);
  counter += 1 + Math.floor(Math.random() * 3);

  return {
    id: `${pick(buyerPrefixes)}-${counter}`,
    commodity: commodity.name,
    quantity: formatQty(qty, commodity.unit),
    destination: pick(destinations),
    buyerRef: `Buyer ${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${Math.floor(
      10 + Math.random() * 89,
    )}`,
    incoterm: pick(incoterms),
    timestamp,
    status: status ?? pick(statuses),
  };
}

/**
 * Builds a backdated ledger spanning the last `weeks` weeks, with several
 * orders per week at varied dates and times, newest first.
 */
export function buildOrderHistory(weeks = 8, perWeek = 5): TradeOrder[] {
  const orders: TradeOrder[] = [];
  const now = Date.now();
  const week = 7 * 24 * 60 * 60 * 1000;

  for (let w = 0; w < weeks; w += 1) {
    for (let i = 0; i < perWeek; i += 1) {
      const dayOffset = Math.floor(Math.random() * 7);
      const hour = 7 + Math.floor(Math.random() * 12);
      const minute = Math.floor(Math.random() * 60);
      const date = new Date(now - w * week - dayOffset * 24 * 60 * 60 * 1000);
      date.setHours(hour, minute, 0, 0);
      if (date.getTime() > now) date.setTime(now - 1000 * 60 * 90);
      const recent: TradeOrder['status'][] = ['Confirmed', 'Assay pending', 'In transit'];
      const mid: TradeOrder['status'][] = ['In transit', 'Cleared customs'];
      const status: TradeOrder['status'] =
        w === 0 ? pick(recent) : w < 3 ? pick(mid) : 'Delivered';
      orders.push(createOrder(date, status));
    }
  }

  return orders.sort((a, b) => b.timestamp.getTime() - a.timestamp.getTime());
}
